<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

<!-- Purposely not hiding the content, so it still occupies space on the document flow -->
<div #collapsedElement
  class="container collapsed {{alternateClass}}">
  <div class="separator-container">
    <ng-container *ngTemplateOutlet="separator"></ng-container>
  </div>
</div>

@if (isOpen) {
  <div #expandedElement
    [ngStyle]="expandedElementPosition"
    class="container expanded"
    data-cy="path-alerts-expanded-container">
    <div class="separator-container">
      <ng-container *ngTemplateOutlet="separator"></ng-container>
      <div class="spacer"></div>
      <div (click)="close()"
        data-cy="path-alerts-close-button"
        class="close flex-center">
        <span class="{{CSS_BUTTON_CLOSE}}"></span>
      </div>
    </div>
    <div #menuElement
      class="menu"
      data-cy="path-alerts-breadcrumb-list">
      <ng-container *ngTemplateOutlet="menuLine"></ng-container>
    </div>
  </div>
}


<ng-template #separator>
  @for (separator of separators | anyKeyValue; track separator) {
    <div
      (click)="separatorClick(separator.key)"
      [attr.data-cy]="separatorDataCy(separator.key)"
      class="separator flex-center {{separatorActiveClass(separator.key)}}">
      <span class="indicator flex-center {{separatorIconClass(separator.key)}}"
      [attr.data-cy]="separatorIndicatorDataCy(separator.key)"></span>
      <app-status-dot class="{{separator.key}}"
      [attr.data-cy]="separatorStatusDotDataCy(separator.key)"></app-status-dot>
      <app-tooltip [message]="separatorLabel(separator)"
        class="display-inline-flex"
        (shown)="forceCloseFullLineTooltip.emit()">
        <span class="label"
        [attr.data-cy]="separatorLabelDataCy(separator.key)">{{separatorLabel(separator)}}</span>
      </app-tooltip>
    </div>
  }
</ng-template>


<ng-template #menuLine>
  @if (separators?.get(state.openSeparator)?.hasAccordion) {
    @for (entity of separators?.get(state.openSeparator)?.entities; track entity; let isLast = $last) {
      <div (click)="lineClick(entity)"
        class="line {{accordionActiveClass(entity)}}"
        [attr.data-cy]="entityLineDataCy($safeNavigationMigration(entity?.value?.code))">
        <div class="indicator flex-center" [attr.data-cy]="entityIndicatorDataCy($safeNavigationMigration(entity?.value?.code))"><span
        class="{{accordionIconClass(entity)}}"></span></div>
            <ng-container *ngTemplateOutlet="lineElements; context: {
                label: entityLabel(entity),
                element: entity,
                view: viewEntity,
                edit: editEntity,
                hasView: hasViewEntityButton,
                hasEdit: hasEditEntityButton,
                dataCy: entityLineDataCy($safeNavigationMigration(entity?.value?.code))
            }"></ng-container>
      </div>
      @if (isAccordionActive(entity)) {
        <div
          class="accordion {{lastAccordionStyle(isLast)}}"
          [attr.data-cy]="lineAccordionDataCy($safeNavigationMigration(entity?.value?.code))">
          @for (path of entity.paths; track path; let i = $index) {
            <div
              class="line"
              data-cy="path-alerts-line-accordion-element">
                <ng-container *ngTemplateOutlet="lineElements; context: {
                    label: pathLabel(path),
                    element: entity,
                    view: viewPath,
                    edit: editPath,
                    path: path,
                    hasView: hasViewPathButton,
                    hasEdit: hasEditPathButton,
                    dataCy: pathLineDataCy($safeNavigationMigration(entity?.value?.code), i)
                }"></ng-container>
            </div>
          }
        </div>
      }
    }
  } @else {
    @for (entity of separators?.get(state.openSeparator)?.entities; track entity) {
      <div class="accordion is-last">
        @for (path of entity.paths; track path; let i = $index) {
          <div
            class="line"
            [attr.data-cy]="pathLineDataCy($safeNavigationMigration(entity?.value?.code), i)">
                <ng-container *ngTemplateOutlet="lineElements; context: {
                    label: pathLabel(path),
                    element: entity,
                    view: viewPath,
                    edit: editPath,
                    path: path,
                    hasView: hasViewPathButton,
                    hasEdit: hasEditPathButton,
                    dataCy: pathLineDataCy($safeNavigationMigration(entity?.value?.code), i)
                }"></ng-container>
          </div>
        }
      </div>
    }
  }
</ng-template>






<ng-template #lineElements
  let-edit="edit"
  let-element="element"
  let-label="label"
  let-view="view"
  let-path="path"
  let-hasEdit="hasEdit"
  let-hasView="hasView"
  let-dataCy="dataCy">
  <span class="breadcrumb" data-cy="path-alerts-line-element">
    <app-tooltip [message]="label"
      (shown)="forceCloseFullLineTooltip.emit()">
      <span class="label" data-cy="path-alerts-line-element-label">{{label}}</span>
    </app-tooltip>
  </span>
  <div class="spacer"></div>
  @if (hasView) {
    <div (click)="view(path, element, $event)"
      class="action flex-center view"
      [attr.data-cy]="lineElementViewButtonDataCy(dataCy)">
      <app-tooltip [dynamic]="false"
        message="View"
        (shown)="forceCloseFullLineTooltip.emit()">
        <span class="{{CSS_BUTTON_VIEW}}"></span>
      </app-tooltip>
    </div>
  }
  @if (hasEdit) {
    <div (click)="edit(path, element, $event)"
      class="action flex-center edit"
      [attr.data-cy]="lineElementEditButtonDataCy(dataCy)">
      <app-tooltip [dynamic]="false"
        message="Edit"
        (shown)="forceCloseFullLineTooltip.emit()">
        <span class="{{CSS_BUTTON_EDIT}}"></span>
      </app-tooltip>
    </div>
  }
</ng-template>

